/**
 * Chat page paths. Exact `/chat` or a conversation under `/chat/` — never
 * a coincidental prefix like `/chatty`.
 */
export const CHAT_MEMORY_PATH = '/chat/memory'

export function isChatPath(pathname: string): boolean {
  return pathname === '/chat' || pathname.startsWith('/chat/')
}

export function isChatMemoryPath(pathname: string): boolean {
  return pathname === CHAT_MEMORY_PATH
}

/**
 * Full-page chat URL for the rail's active conversation. An ingest session has
 * no chat page of its own — it expands to the job page instead, so callers pass
 * `null` for one.
 */
export function chatFullPagePath(activeTabId: string | null): string {
  if (activeTabId === null) return '/chat'
  return `/chat/${activeTabId}`
}

/**
 * Left-nav Chat destination. While already on a chat route this is a no-op so
 * clicking Chat does not dump an open thread onto the landing. From any other
 * section, restore the focused conversation (or the landing if there is none).
 */
export function chatNavPath(pathname: string, activeTabId: string | null): string {
  if (isChatPath(pathname)) return pathname
  return chatFullPagePath(activeTabId)
}
